import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PaymentPage = () => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("upi");

  const handlePayment = () => {
    alert(`Payment method selected: ${paymentMethod}`);
    navigate("/confirm");
  };

  return (
    <div style={styles.container}>
      <h2>Complete Your Payment</h2>
      <div style={styles.card}>
        <h3>Product Name</h3>
        <p>Amount: ₹XXXX</p>
        <div style={styles.paymentOptions}>
          <label>
            <input 
              type="radio" 
              name="paymentMethod" 
              value="upi" 
              checked={paymentMethod === "upi"} 
              onChange={() => setPaymentMethod("upi")} 
            />
            UPI
          </label>
          <label>
            <input 
              type="radio" 
              name="paymentMethod" 
              value="card" 
              checked={paymentMethod === "card"} 
              onChange={() => setPaymentMethod("card")} 
            />
            Credit/Debit Card
          </label>
          <label>
            <input 
              type="radio" 
              name="paymentMethod" 
              value="cash" 
              checked={paymentMethod === "cash"} 
              onChange={() => setPaymentMethod("cash")} 
            />
            Cash on Delivery
          </label>
        </div>
        <button style={styles.button} onClick={handlePayment}>
          {paymentMethod === "cash" ? "Place Order" : "Proceed to Pay"}
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "#f5f5f5",
  },
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  paymentOptions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: "10px 0",
  },
  button: {
    background: "#ff6600",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
  },
};

export default PaymentPage;
